import { defineComponent, PropType } from 'vue'
import './index.scss'
import { BaseNewsCard, BaseNewsSwiper, GfrContainer, ModuleBase, ModuleBaseHeader } from '#components'
import { moduleBaseProps } from '@/components/module/base'
export interface NewsItem {
  title: string
  tag?: string
  image: string
  publish_time: number
  weight: number
  url: string
  display: number // 前端过滤 0 ｜ 1
}
export default defineComponent({
  name: 'ModuleHomeScreen2',
  props: {
    ...moduleBaseProps,
    title: String,
    subtitle: String,
    list: {
      type: Array as PropType<NewsItem[]>,
      default: () => []
    }
  },
  setup(props) {
    const newsList = computed(() => {
      return props.list
        .filter((item) => item.display === 1)
        .sort((a, b) => b.weight - a.weight)
        .slice(0, 3)
    })
    return () => (
      <ModuleBase name={props.name} class={'module-home-news-base'}>
        <GfrContainer class="module-home-news">
          <ModuleBaseHeader title={props.title} description={props.subtitle || ''}>
            {/* <GfrButton class="flex-shrink-0 h-8 text-primary-color text-m-p border border-primary-color rounded-[2px] font-bold bg-primary-color/10">
              <NuxtLink class="inline-flex items-center justify-center w-full h-full px-4 py-1" to='/'>
                VIEW MORE
                <IconsLinkArrow class="rotate-180 w-3.5 h-3.5 ml-1" />
              </NuxtLink>
            </GfrButton> */}
          </ModuleBaseHeader>
          <div class="module-home-news-wrapper max-lg:portrait:hidden">
            <div class="module-home-news-list">
              {newsList.value.map((item) => (
                <BaseNewsCard card={item} />
              ))}
            </div>
          </div>
          <BaseNewsSwiper class="max-lg:portrait:block hidden mt-3" list={newsList.value} />
        </GfrContainer>
      </ModuleBase>
    )
  }
})
